module.exports = __webpack_public_path__ + "static/media/8-Spades.8a86fc82.svg";